import Axios from "@/models/axios";

class ReleaseApi extends Axios {
  path() {
    return 'papi/Release';
  }
}

export default ReleaseApi;
